var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',[_c('HeroHeader2'),_vm._v(" "),_c('div',{staticClass:"site-content"},[_c('CTA3'),_vm._v(" "),_c('intro'),_vm._v(" "),_c('Story'),_vm._v(" "),_c('Features2'),_vm._v(" "),_c('Images'),_vm._v(" "),_c('PressContent'),_vm._v(" "),_c('Corsair'),_vm._v(" "),_c('CTA3'),_vm._v(" "),_c('Footer')],1)],1)}
var staticRenderFns = []
var esExports = { render: render, staticRenderFns: staticRenderFns }
export default esExports


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-4ac36114","hasScoped":false,"transformToRequire":{"video":["src","poster"],"source":"src","img":"src","image":"xlink:href"},"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./src/views/Home/Home.vue
// module id = null
// module chunks = 